import React, { useState } from 'react';
import styles from './AdminsTab.module.scss';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Filter } from '../Filter';
import { Map } from '../../../../modules/tt-map';
import ListMode from '../ListMode';
import GridMode from '../GridMode';

export const AdminsTab = ({ admins }) => {
  const router = useNavigate();
  const mapApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
  const [loading, setLoading] = useState(false);
  const [scrollLoading, setScrollLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [getMore, setGetMore] = useState(false);
  const [filters, setFilters] = useState({
    limit: 15,
    order_dir: 'desc',
    page: 1,
    q: '',
  });
  const [activeMode, setActiveMode] = useState(
    localStorage.getItem('mode') ? localStorage.getItem('mode') : 'list'
  );
  const result = false;
  const fetchMoreAdmins = async () => {
    if (page < pageCount && !loading) {
      const pageNumber = page + 1;
      setPage(pageNumber);
      setGetMore(true);
      setFilters({ ...filters, page: pageNumber });
    }
  };

  const onScrollAdmins = async (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const maxScroll = scrollHeight - scrollTop - 1;
    if (maxScroll <= clientHeight) {
      await fetchMoreAdmins();
    }
  };
  return (
    <>
      <Box className={styles.filtersAndList}>
        <Filter activeMode={activeMode} changeActiveMode={(mode) => setActiveMode(mode)} />
        <Box className={styles.foundedCount}>{admins.length} people were found by request</Box>
        {activeMode === 'map' &&
          !loading &&
          (result ? (
            <Box
              sx={{
                height: '100%',
                borderRadius: 4,
                display: 'flex',
                justifyContent: 'center',
                my: 2,
                p: 2,
                backgroundColor: '#FFFFFF',
              }}
            >
              <Map
                clickMarker={(id) => router(`/dashboard/profile/${id}`)}
                showSearch={false}
                isList
                coordinatesList={result}
                apiKey={mapApiKey}
              />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
              <Typography>List is empty</Typography>
            </Box>
          ))}
        <Box>
          {activeMode === 'list' && (
            <ListMode loading={scrollLoading} onScroll={onScrollAdmins} users={admins} />
          )}
          {activeMode === 'grid' && (
            <GridMode loading={scrollLoading} onScroll={onScrollAdmins} users={admins} />
          )}
        </Box>
      </Box>
    </>
  );
};
